import React, { useCallback } from "react";
import { useFormik } from "formik";
import { Trans } from "react-i18next";
import { useGetPhonePrefixesQuery, useGetRegionsQuery } from "../../../api";
import { fetchCreateApplication } from "../../../api/application.api";
import { Input } from "../../../components/simple/Input";
import { ECommerceValidation } from "./validationSchema";
import { history } from "../../../helpers/history";
import i18n from "../../../i18n";
import { Column, Grid, Row } from "carbon-components-react";
import { Icon } from "../../../components/simple/Icon";
import { Phone } from "../../../components/simple/Phone";
import LbCheckBox from "../../../components/simple/LbCheckBox";
import { LbLoader } from "../../../components/simple/LbLoader";
import { LbToolTip } from "../../../components/simple/LbToolTip";

export const Index = () => {
  const { data: options, isError, error, isLoading } = useGetRegionsQuery();
  const { data: phoneOptions, isLoading: isPhoneOptionsLoading } =
    useGetPhonePrefixesQuery();
  const formik = useFormik({
    initialValues: {
      productTypes: ["ECOMERCE"],
      contactName: "",
      contactEmail: "",
      contactPhone: "",
      companyCode: "",
      companyName: "",
      companyWebSite: "",
      enableCashback: true,
      phonePrefixes: {
        code: "+995",
        country: "Georgia",
        exampleNumber: i18n.t("Common.Phone.Placeholder"),
        format: "(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}",
        id: "GE",
        label: "+995",
        value: "GE",
      },
      agree: false,
    },
    validationSchema: ECommerceValidation,
    onSubmit: async (values, methods) => {
      const { setSubmitting, resetForm } = methods;
      try {
        setSubmitting(true);
        await fetchCreateApplication({
          ...values,
        });
        resetForm();
        setSubmitting(false);
        history.push("/application/create/complete", {
          type: "success",
          productType: "ECOMERCE",
        });
      } catch (error) {
        history.push("/application/create/complete", {
          type: "error",
          productType: "ECOMERCE",
        });
      }
    },
  });
  const handelEnableCashBack = useCallback(
    async (val) => {
      await formik.setFieldValue("enableCashback", val);
    },
    [formik]
  );

  const handlePrefix = useCallback(
    async (val) => {
      await formik.setFieldValue("phonePrefixes", val);
    },
    [formik]
  );

  const handelAgree = useCallback(
    async (e) => {
      // e.preventDefault();
      await formik.setFieldValue("agree", !formik.values.agree);
    },
    [formik]
  );

  console.log(formik.errors);
  return (
    <Grid>
      <Row>
        <Column lg={12}>
          <div className="w-768">
            {/* ელექტრონული კომერცია */}
            <div className="text-center mb-64 mt-64">
              <h4 className="productive-heading-04 mb-24">
                <Trans i18nKey="Application.ECommerce.Title" />
              </h4>
              <p>
                <Trans i18nKey="Application.ECommerce.Description" />
              </p>
            </div>

            <div className="la-electronic-commerce">
              {/* <div className="la-electronic-commerce__row"> */}
              <Input
                label={i18n.t("Application.ECommerce.contactName")}
                name="contactName"
                value={formik.values.contactName}
                onChange={formik.handleChange("contactName")}
                onBlur={formik.handleBlur("contactName")}
                error={
                  "contactName" in formik.errors &&
                  "contactName" in formik.touched
                }
              />
              <Phone
                phoneOptions={phoneOptions}
                isLoading={isLoading}
                label={i18n.t("Application.ECommerce.contactPhone")}
                placeholder={
                  (formik.values.phonePrefixes &&
                    formik.values.phonePrefixes.exampleNumber) ||
                  i18n.t("Application.ECommerce.contactPhone.Placeholder")
                }
                name="contactPhone"
                value={formik.values.contactPhone}
                prefixValue={formik.values.phonePrefixes}
                onChange={formik.handleChange("contactPhone")}
                onPrefixChange={handlePrefix}
                onBlur={formik.handleBlur("contactPhone")}
                error={
                  "contactPhone" in formik.errors &&
                  "contactPhone" in formik.touched
                }
              />

              {/* </div> */}
              {/* <div className="la-electronic-commerce__row"> */}
              <Input
                label={i18n.t("Application.ECommerce.contactEmail")}
                name="contactEmail"
                value={formik.values.contactEmail}
                onChange={formik.handleChange("contactEmail")}
                onBlur={formik.handleBlur("contactEmail")}
                error={
                  "contactEmail" in formik.errors &&
                  "contactEmail" in formik.touched
                }
              />
              <Input
                label={i18n.t("Application.ECommerce.companyName")}
                name="companyName"
                value={formik.values.companyName}
                onChange={formik.handleChange("companyName")}
                onBlur={formik.handleBlur("companyName")}
                error={
                  "companyName" in formik.errors &&
                  "companyName" in formik.touched
                }
              />
              {/* </div> */}
              {/* <div className="la-electronic-commerce__row"> */}

              <Input
                label={i18n.t("Application.ECommerce.companyCode")}
                name="companyCode"
                onChange={formik.handleChange("companyCode")}
                onBlur={formik.handleBlur("companyCode")}
                value={formik.values.companyCode}
                error={
                  "companyCode" in formik.errors &&
                  "companyCode" in formik.touched
                }
                placeholder={i18n.t(
                  "Application.ECommerce.companyCode.Placeholder"
                )}
              />

              <Input
                regex="[a-zA-Z]"
                label={i18n.t("Application.ECommerce.companyWebSite")}
                name="companyWebSite"
                value={formik.values.companyWebSite}
                onChange={formik.handleChange("companyWebSite")}
                onBlur={formik.handleBlur("companyWebSite")}
                error={
                  "companyWebSite" in formik.errors &&
                  "companyWebSite" in formik.touched
                }
              />
              {/* </div> */}

              <div className="cashback-request">
                <div>
                  <p className="description">
                    {i18n.t("Application.Pos.EnableCashBack")}
                  </p>
                  <i className="icn" id="information1">
                    <Icon name="information" viewBox="0 0 20 20" />
                  </i>

                  <LbToolTip
                    forId="information1"
                    html={i18n.t("ECommerce.EnableCashBack.Tooltip")}
                    place="right"
                  />
                </div>
                <div className="cashback-request--btns">
                  <label className="container mr-26">
                    {i18n.t("Common.Yes")}
                    <input
                      type="radio"
                      name="radio"
                      onClick={() => handelEnableCashBack(true)}
                      checked={formik.values.enableCashback}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="container">
                    {i18n.t("Common.No")}
                    <input
                      type="radio"
                      name="radio"
                      onClick={() => handelEnableCashBack(false)}
                      checked={!formik.values.enableCashback}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>

              <div className="agreement-terms mb-32">
                <p className="agreement-terms__details code-02">
                  {i18n.t("Application.ECommerce.AgreeRules")}
                </p>
                <LbCheckBox
                  id="agree"
                  i18nKey="Application.ECommerce.AcceptRules"
                  name="agree"
                  value={formik.values.agree}
                  checked={!!formik.values.agree}
                  onLabelClick={handelAgree}
                  onChange={handelAgree}
                  onBlur={formik.handleBlur("agree")}
                  error={"agree" in formik.errors && "agree" in formik.touched}
                />
              </div>

              <button
                className={`btn btn-black btn-request`}
                type="button"
                disabled={
                  !formik.dirty || formik.isSubmitting || !formik.isValid
                }
                onClick={formik.submitForm}
              >
                {formik.isSubmitting ? (
                  <LbLoader isLoading />
                ) : (
                  <Trans i18nKey="Common.Create" />
                )}
              </button>
            </div>
          </div>
        </Column>
      </Row>
    </Grid>
  );
};
